import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { useLazyPublishItemQuery } from "../../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Publish(
        selectedItems: any[], 
        waitFor: boolean, 
        setWaitFor: (waitFor: boolean) => void, 
        setIsPublish: (isPublish: boolean) => void, 
        setShowCheckinDialog: (showCheckinDialog: boolean) => void, 
        isInOneDrive: boolean,
        setGridItemIsBusy: (items: any[], isBusy: boolean) => void, 
        updateGridItems: (items: any[]) => void,
        setIsCMErrorModalOpen: (isCMErrorModalOpen: boolean) => void,
        setErrorMessage?: (errorMessage: string) => void
    ) {
    const languageStrings = React.useContext(LanguageContext);
    
    const [menuItem_Publish, setMenuItem_Publish] = React.useState<IContextualMenuItem>();
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const [publishItem] = useLazyPublishItemQuery();

    React.useEffect(() => {
        if (!isInOneDrive && 
            selectedItems.length === 1 && 
            !selectedItems[0].CheckoutUser &&
            !selectedItems[0]?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)
        ) {
            const minorVersion = +selectedItems[0]._UIVersion % 512;
            
            if (minorVersion > 0 && !isInPending()) { 
                setMenuItem_Publish(
                    {
                        key: 'publish',
                        disabled: waitFor === true,
                        name: isInDraftOrRejected() ? languageStrings.SubmitForApproval : languageStrings.Publish,
                        iconProps: { iconName: "PublishContent" },
                        onClick: () => {
                            if (isInDraftOrRejected()) {
                                submitForApproval();
                            } else {
                                setIsPublish(true);
                                setShowCheckinDialog(true);
                            }

                        }
                    }
                )
            } else {
                setMenuItem_Publish(null)
            }
        } else {
            setMenuItem_Publish(null)
        }
        
    }, [selectedItems, waitFor, isInOneDrive, currentDirectory]);

    const isInDraftOrRejected  = () => {
        if (selectedItems[0]['_ModerationStatus.']) {
            return selectedItems[0]['_ModerationStatus.'] === '3' || selectedItems[0]['_ModerationStatus.'] === '1';
        }
        return false;        
    }

    const isInPending = () => {
        if (selectedItems[0]['_ModerationStatus.']) {
            return selectedItems[0]['_ModerationStatus.'] === '2';
        }

        return false;
    }

    const submitForApproval = async () => {
        setGridItemIsBusy(selectedItems, true);
        setWaitFor(true);

        try {
            await publishItem({
                siteUrl: currentDirectory?.webUrl,
                uniqueId: selectedItems[0].UniqueId.replace("{", "").replace("}", ""),
                accessToken: isInOneDrive ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                comment: ''
            }).unwrap();
        } catch (error) {
            setIsCMErrorModalOpen(true);          
            setErrorMessage(error['data']['odata.error']['message']['value']);
        }

        updateGridItems(selectedItems);
        setWaitFor(false);
    }

    return {
        menuItem_Publish
    }

}